package one.devsbox.www.ui.users

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime
import one.devsbox.commons.EMPTY
import one.devsbox.commons.nowDateTime
import one.devsbox.shared.ads.SharedIO
import one.devsbox.shared.ads.UserAction
import one.devsbox.shared.ads.TargetType
import org.jetbrains.compose.resources.StringResource
import androidx.compose.ui.graphics.vector.ImageVector
import compose.assets.Svg
import compose.assets.svg.*
import one.devsbox.www.www_portal.generated.resources.*
import org.jetbrains.compose.resources.stringResource
import kotlin.time.Clock
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.minutes

fun UserAction.icon(): ImageVector = when (this) {
    UserAction.VIEW -> Svg.EyeOutline
    UserAction.ADD -> Svg.Plus
    UserAction.CHANGE -> Svg.EditOutline
    UserAction.DELETE -> Svg.TrashOutline
}

fun TargetType.icon(): ImageVector = when (this) {
    TargetType.USER -> Svg.UserOutline
    TargetType.RESOURCE -> Svg.MediaOutline
    TargetType.DEVICE -> Svg.DeviceOutline
    TargetType.LOCATION -> Svg.LocationOutline
    TargetType.CAMPAIGN -> Svg.CampaignOutline
    TargetType.COMPANY -> Svg.ListBoxOutline
}

fun UserAction.text(): StringResource = when (this) {
    UserAction.VIEW -> Res.string.ui_action_view
    UserAction.ADD -> Res.string.ui_action_add
    UserAction.CHANGE -> Res.string.ui_action_change
    UserAction.DELETE -> Res.string.ui_action_delete
}

fun TargetType.text(idTarget: Long): StringResource = when (this) {
    TargetType.USER -> if (idTarget > 0) Res.string.ui_target_user else Res.string.ui_target_users
    TargetType.RESOURCE -> if (idTarget > 0) Res.string.ui_target_resource else Res.string.ui_target_resources
    TargetType.DEVICE -> if (idTarget > 0) Res.string.ui_target_device else Res.string.ui_target_devices
    TargetType.LOCATION -> if (idTarget > 0) Res.string.ui_target_location else Res.string.ui_target_locations
    TargetType.CAMPAIGN -> if (idTarget > 0) Res.string.ui_target_campaign else Res.string.ui_target_campaigns
    TargetType.COMPANY -> if (idTarget > 0) Res.string.ui_target_company else Res.string.ui_target_companies
}

@Composable
fun UserAction.color() = when (this) {
    UserAction.VIEW -> MaterialTheme.colorScheme.outline
    UserAction.ADD -> MaterialTheme.colorScheme.primary
    UserAction.CHANGE -> MaterialTheme.colorScheme.secondary
    UserAction.DELETE -> MaterialTheme.colorScheme.error
}

@Composable
fun SharedIO.UserSimple.lastActivity(): String = activity.formatAsLastActivity()

@Composable
fun SharedIO.User.lastActivity(): String = activity.formatAsLastActivity()

@Composable
fun LocalDateTime.formatAsLastActivity(): String {
    val now = Clock.nowDateTime(true)
    val nowInstant = now.toInstant(TimeZone.currentSystemDefault())
    val activityInstant = toInstant(TimeZone.UTC)
    val diff = nowInstant - activityInstant

    return when {
        this == LocalDateTime.EMPTY -> "-"
        diff < 1.minutes -> stringResource(Res.string.ui_users_activity_now)
        diff < 24.hours -> {
            if (diff < 1.hours) {
                stringResource(Res.string.ui_users_activity_mins_ago, diff.inWholeMinutes.toInt())
            } else {
                stringResource(Res.string.ui_users_activity_hours_ago, diff.inWholeHours.toInt())
            }
        }

        else -> activityInstant.toLocalDateTime(TimeZone.UTC).toString().replace("T", " ").take(16)
            .uppercase()
    }
}